import { useDispatch } from 'react-redux';
import { setEventData } from '../../../Redux/store';
import EventRow from '../../../Pages/Calendar/Desktop/EventRow';

function EventsList({ events, date }) {
  const dispatch = useDispatch();

  const handleAdd = () => {
    dispatch(setEventData({ id: 'new', title: '', contact: '', status: 'pending', note: '', date }));
  };

  const handleClickEvent = (eventId) => {
    const event = events?.find(e => e.id === eventId);
    if (event) {
      dispatch(setEventData(event));
    }
  };

  return (
    <div className={`${events?.length ? 'flex-1' : 'flex-shrink-0'} flex flex-col min-h-0`}>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-primary flex-shrink-0">
        Events {events?.length > 0 && `(${events.length})`}
      </p>
      <ul className={`${events?.length ? 'flex-1' : ''} space-y-2 overflow-y-auto min-h-0`}>
        {/* Add event button */}
        <li className="mb-2">
          <button
            onClick={handleAdd}
            className="flex w-full items-center justify-center gap-1 rounded-xl border border-dashed border-primary/30 py-2 text-xs text-primary hover:border-primary/60 hover:bg-primary/5"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            Add event
          </button>
        </li>
        {/* Events */}
        {events?.map((ev) => (
          <li
            key={ev.id}
            onClick={() => handleClickEvent(ev.id)}
            className="flex items-center gap-3 rounded-xl bg-secondary p-[2px] cursor-pointer hover:bg-secondary/80 transition-colors"
          >
            <div className="flex-1 min-w-0">
              <EventRow eventData={ev} size="md" />
            </div>
            <div className="flex items-center gap-2 ml-2">
              {ev.status && (
                <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-medium text-primary capitalize">
                  {ev.status}
                </span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default EventsList;
